module.exports = __webpack_public_path__ + "static/media/google-drive.d5e259bf.svg";